import { render } from "./TFLoading.vue?vue&type=template&id=223f1922&scoped=true"
const script = {}

import "./TFLoading.vue?vue&type=style&index=0&id=223f1922&scoped=true&lang=scss"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223f1922"]])

export default __exports__